import { Routes } from '@angular/router';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { passwordChangeRequiredGuard } from '@app/core/guards/password-change-required.guard';
import { UserResolver } from '@app/core/resolvers/user.resolver';
import { ForbiddenPageComponent } from '@app/shared/components/forbidden-page/forbidden-page.component';
import { ShellComponent } from '@app/shell/components/shell/shell.component';
import { NotFoundPageComponent } from '@shared/components/not-found-page/not-found-page.component';
import { UserPermissionCodeEnum } from './core/enums/user-permission-code.enum';
import { UserGuard } from './core/guards/user.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',
  },
  {
    path: 'unauthorized',
    pathMatch: 'full',
    redirectTo: '/',
  },
  {
    path: '403',
    canActivate: [AuthGuard],
    resolve: { user: UserResolver },
    component: ForbiddenPageComponent,
  },
  {
    path: '404',
    component: NotFoundPageComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: { user: UserResolver },
    component: ShellComponent,
    children: [
      {
        path: '',
        canMatch: [passwordChangeRequiredGuard],
        children: [
          {
            path: 'users',
            canActivate: [UserGuard],
            data: {
              permissions: [UserPermissionCodeEnum.VIEW_USER],
            },
            loadChildren: () => import('@app/users/users.routes').then((m) => m.routes),
          },
          {
            path: 'dashboard',
            loadChildren: () => import('@dashboard/dashboard.routes').then((m) => m.routes),
          },
          {
            path: 'profile',
            loadChildren: () => import('@app/profile/profile.routes').then((m) => m.routes),
          },
          {
            path: 'release-notes',
            loadChildren: () => import('@settings/settings.routes').then((m) => m.routes),
          },
          {
            path: 'admin',
            canActivate: [UserGuard],
            data: {
              permissions: [UserPermissionCodeEnum.VIEW_ADMIN_AREA],
            },
            loadChildren: () => import('@admin/admin.routes').then((m) => m.routes),
          },
          {
            path: 'models',
            canActivate: [UserGuard],
            data: {
              permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
            },
            loadChildren: () => import('@models/models.routes').then((m) => m.routes),
          },
          {
            path: 'scenarios',
            canActivate: [UserGuard],
            data: {
              permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
            },
            loadChildren: () => import('@scenarios/scenarios.routes').then((m) => m.routes),
          },
          {
            path: 'scenario-result',
            canActivate: [UserGuard],
            data: {
              permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
            },
            loadChildren: () => import('@scenario-result/sankey.diagram.routes').then((m) => m.routes),
          },
          {
            path: 'scenario-builder',
            loadChildren: () => import('@scenario-builder/scenario-builder.routes').then((m) => m.routes),
          },
        ],
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('@app/profile/components/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
